import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  button: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 0,
    "& .MuiButtonBase-root": {
      padding: theme.spacing(0, 4, 0, 4),
    },
    "&.MuiButton-root:not(.Mui-disabled):hover": {
      backgroundColor: "transparent",
      "& .MuiButton-label,& .MuiSvgIcon-root": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiTouchRipple-root": {
      display: "none",
    },
    "& .MuiButton-label": {
      fontWeight: 400,
      fontSize: "14px",
      color: theme.custom.color.mortar,
      textTransform: "capitalize",
    },
    "&.Mui-disabled": {
      pointerEvents: "auto",
      cursor: "not-allowed",
    },
  },
  icon: {
    display: "flex",
    marginRight: theme.spacing(1),
    "& .MuiSvgIcon-root": {
      fontSize: "20px",
    },
  },
  iconSize: {
    fontSize: "20px",
  },
  paper: {
    width: "450px",
    border: "1px solid " + alpha(theme.custom.color.black, 0.1),
    borderRadius: "8px",
    backgroundColor: theme.custom.color.white,
    boxShadow: "0 8px 25px -10px " + alpha(theme.custom.color.black, 0.3),
    padding: theme.spacing(1.5, 2, 2, 2),
  },
  opened: {
    "& .MuiButton-label": {
      color: theme.palette.primary.main,
    },
  },
  footer: {
    paddingTop: theme.spacing(1.5),
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  addBtn: {
    padding: theme.spacing(0, 0.5),
    "& .MuiButton-label": {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "24px",
      textTransform: "capitalize",
      "& .MuiSvgIcon-root": {
        fontSize: "20px",
        marginRight: theme.spacing(1),
      },
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.custom.linkHover.color,
    },
  },
  formControl: {
    width: "calc(100% - 20px)",
    margin: theme.spacing(1, 2.5, 0.5, 0),
    "& .MuiInput-root": {
      "&:after,&:before": {
        display: "none",
      },
    },
    "& .MuiInput-input": {
      fontSize: "14px",
    },
    "& .MuiInput-formControl .MuiInputBase-input:not(.MuiSelect-selectMenu)": {
      padding: 0,
      height: theme.spacing(4),
      marginTop: theme.spacing(2),
    },
  },
  datePicker: {
    "&.MuiFormControl-root": {
      marginBottom: 0,
    },
    "& .MuiInputBase-input": {
      marginTop: "0 !important",
    },
    "& .MuiButtonBase-root": {
      padding: 0,
    },
  },
  field: {
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    "& .MuiInputBase-root": {
      "&:after,&:before": {
        display: "none",
      },
    },
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "1px solid " + alpha(theme.custom.color.gainsboro, 0.5),
  },
  iconBtn: {
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.5),
  },
  placeholder: {
    fontSize: "14px",
    fontWeight: 400,
    letterSpacing: "0.09px",
    color: theme.custom.color.silver,
  },
  btnGrp: {
    display: "flex",
    "& button:first-child": {
      marginRight: theme.spacing(1),
    },
  },
  filterGrp: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
  },
  hidden: {
    visibility: "hidden",
  },
  menuList: {
    textTransform: "capitalize",
  },
  maxHeight: {
    maxHeight: "200px",
  },
}));
